import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { MsalUserService } from '../../applicationinfraestructure/services/msaluser.service';

@Injectable()
export class ValidateRedirectLogin implements CanActivate {

    constructor(private msalService: MsalUserService, private router: Router) { }

    canActivate() {
        const userInfo = this.msalService.getCurrentUserInfo();
        if (userInfo) {
            this.router.navigate(['/home']);
            return true;
        } else {
            this.router.navigate(['/login']);
            return false;
        }
    }
}